export const environment = {
    production: false,
    sbmsUrl: "https://staging.lvconnect.me/api",
    sbmsBaseUrl: "https://staging.lvconnect.me/",
    sbmsBrugesUrl: "https://staging.lvconnect.me/bruges-api",
    webSocketUrl: "ws://localhost:8080/api/open/news-feed",
    vndId: 75,
    brugesId: 25,
    googleClientId: "747123720760-3lkkefd2flbk4vlna22c80rc4k2i00eu.apps.googleusercontent.com",
    mockBookingUuid: "2f399354-b30c-42f0-b673-6d9594ca92f4",
    sbmsVersion: "2.2.4",
    googleOauthConsentUrl: "https://staging.lvconnect.me/api/oauth2",
    lvConnectBaseUrl: "https://staging.lvconnect.me/en",
    vivawalletCheckoutBaseUrl: "https://demo.vivapayments.com/web/checkout",
    backgroundColors: ["#96DCFF", "#0000FF", "#008000"],
    keycloakUrl: "https://auth.lvconnect.me",
    keycloakClientId: "lvconnect-staging"
};
